// extracted by mini-css-extract-plugin
export default {"searchIcon":"searchIcon---tIS2Z","isFocused":"isFocused---FAhBm"};